const optionsWithYear: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

const optionsWithTime: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
};

const formatXAxisDate = (value: string) => {
  const date = new Date(value);

  // Check if the date has meaningful time information (not midnight)
  const hasTime = date.getHours() !== 0 || date.getMinutes() !== 0;

  const options = hasTime ? optionsWithTime : optionsWithYear;
  return date.toLocaleDateString('en-US', options);
};

export default formatXAxisDate;
